<template>
  <div
    data-test="authority"
    :class="{
      'is-blurred': loading,
      'is-invisible': loading && !supportsBlur
    }"
  >
    <div>
      <h6>{{ $t('seo_service.sub_headings.your_website') }}</h6>
      <progress
        class="progress is-info is-medium"
        :value="data"
        :max="max"
      >
        <span
          data-test="score"
          class="text-in-bar"
        >{{ data.toFixed() }}/{{ max }}</span>
      </progress>
    </div>
  </div>
</template>

<script>

export default {
  name: 'BaseWebsiteAuthority',

  props: {
    data: {
      type: [String, Number],
      default: 0
    },
    loading: {
      type: Boolean,
      default: false
    },
    supportsBlur: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    max () {
      return 100
    }
  }
}
</script>

<style scoped>

.text-in-bar {
  margin-left: 2px;
  font-size: 1.2em;
  position: absolute;
  color: #75da75;
  mix-blend-mode: luminosity;
}
</style>
